import { Box, Paper, styled } from "@mui/material";

export const UMWrapper = styled(Box)({
    backgroundColor: "#F8F9FA",
    // border: "1px solid red",
    height: "100%"
})

export const UMPaper = styled(Paper)({
    margin: "0px 24px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    border: "4px 4px 4px 4px",
})